import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoMisionVision from "../servicios/InfoMisionVision";
const Footer = lazy(() => import('../footer/Footer'));
function PoliticaCalidad() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="En Hyundai nos preocupamos por tu seguridad."
        />
        <meta name="keywords" content="politica, calidad, Hyundai" />
        <title>Mision y Vision | Hyundai</title>
      </Helmet>
      <Menu />
      <InfoMisionVision />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default PoliticaCalidad;